<template>
    <div class="c-selectLocalization">
        <h3>Wybierz serwis</h3>
        <p v-if="lead.dealer_name">
            Wybrano: <strong>{{ lead.dealer_name }}</strong>
        </p>
        <hr>
        <div class="c-selectLocalization__item"
            v-for="localization in  getLocalizations"
            :key="localization.name"
            v-on:click="selectedLocalization = localization;"
            v-bind:class="{'c-selectLocalization__item--selected':selectedLocalization == localization}">
            <div class="c-selectLocalization__label">
                {{ localization.name }}
                <img src="@/assets/images/tick.png" alt="<">
            </div>
            <div class="c-selectLocalization__content">
                <div class="c-selectLocalization__image">
                    <img :src="localization.image" :alt="localization.name">
                </div>
                <div>
                    <strong>{{ localization.name }}</strong>
                    <p>
                        {{localization.postcode}},{{localization.city}}
                        <br>
                        {{ localization.street  }}
                    </p>
                    <button v-on:click="lead.dealer_name = localization.name; lead.dealer_id = localization.id" v-if="lead.dealer_name != localization.name" >Wybierz</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import lead from '../mixins/lead.js'
    export default {
        data(){
            return {
                selectedLocalization:null
            }
        },
        mixins:[lead],
        computed: {
            ...mapGetters([
                'getLocalizations',
            ])
        },
        mounted(){
          
          var urlLocalization = new URL(location.href).searchParams.get('localization');
          if (urlLocalization !== null) {
            switch (urlLocalization.toLowerCase()) {
              case "czestochowa":
              this.selectedLocalization = this.getLocalizations[0];
              this.lead.dealer_name = this.getLocalizations[0].name;
              this.lead.dealer_id = this.getLocalizations[0].id
              break;
              case "centrum-lodz":
              this.selectedLocalization = this.getLocalizations[1];
              this.lead.dealer_name = this.getLocalizations[1].name;
              this.lead.dealer_id = this.getLocalizations[1].id
              break;
              case "lodz":
              this.selectedLocalization = this.getLocalizations[2];
              this.lead.dealer_name = this.getLocalizations[2].name;
              this.lead.dealer_id = this.getLocalizations[2].id
              break;
              case "wolica":
              this.selectedLocalization = this.getLocalizations[3];
              this.lead.dealer_name = this.getLocalizations[3].name;
              this.lead.dealer_id = this.getLocalizations[3].id
              break;
              case "warszawa":
              this.selectedLocalization = this.getLocalizations[4];
              this.lead.dealer_name = this.getLocalizations[4].name;
              this.lead.dealer_id = this.getLocalizations[4].id
              break;
              case "bialoleka":
              this.selectedLocalization = this.getLocalizations[5];
              this.lead.dealer_name = this.getLocalizations[5].name;
              this.lead.dealer_id = this.getLocalizations[5].id
              break;
            }
          }

        }
    };
</script>
<style lang="scss">
    .c-selectLocalization{
        $t:&;
        width: 100%;
        @media(min-width:780px){
            margin: 0 1rem;
        }
        &__label{
            padding: 2rem 1rem;
            border-bottom: 1px solid #000;
            position: relative;
            cursor: pointer;
            img{
                position: absolute;
                right: 1rem;
                top: 50%;
                transform: translateY(-50%) rotate(0deg);
            }
        }
        &__content{
            height: 1px;
            opacity: 0;
            transition: all .5s;
            display: flex;
        }
        &__item{
            &--selected{
                #{$t}__content{
                    padding: 1rem;
                    height: 210px;
                    opacity: 1;
                }
                #{$t}__label{
                    font-weight: bold;
                    img{
                        transform: translateY(-50%) rotate(90deg);
                    }
                }
            }
        }
        &__image{
            margin-right: 1rem;
        }
        button{
            padding: .5rem 1rem;
            font-size: 1rem;
            display: block;
            cursor: pointer;
        }
    }
</style>
